<template>
  <div class="wrapper">
    <div class="header">
      <img :src="require('@/assets/images/hsk/need-download-close.png')" @click="handleClose" />
    </div>

    <img class="txt" :src="require('@/assets/images/hsk/need-download-txt.png')" />

    <DownLoadApp
      :isMobile="false"
      :whiteIcon="false"
      :isColumn="false"
      :gap="9"
      :hide-icon="true"
      @handleClick="handleClick"
    ></DownLoadApp>
  </div>
</template>

<script>
import analytics from '@/utils/AnalyticsCenter'
import DownLoadApp from '@/components/common/DownLoadApp.vue'

export default {
  data() {
    return {}
  },
  components: {
    DownLoadApp,
  },
  emits: ['close-modal'],
  methods: {
    handleClose() {
      this.$emit('close-modal')
    },
    handleClick(key) {
      // TODO：关于我们、意见反馈、app下载地址、copyright
      let mixpanelParams = { position: 'homepage' }
      if (key === 'android') {
        //安卓下载埋点
        analytics.logEvent('hskweb_android_click', mixpanelParams)
        window.open(
          this.isChina
            ? process.env.VUE_APP_MODE == 'prod'
              ? `${this.$store.state.publicUrl.mockPublicUrl}/static/android/com.wohui.mocktest.china-mockChina-prod.apk`
              : `${this.$store.state.publicUrl.mockPublicUrl}/static/android/com.wohui.mocktest.china-mockChina-test.apk`
            : process.env.VUE_APP_MODE == 'prod'
            ? `${this.$store.state.publicUrl.mockPublicUrl}/static/android/com.wohui.mocktest-foreign-prod.apk`
            : `${this.$store.state.publicUrl.mockPublicUrl}/static/android/com.wohui.mocktest-foreign-test.apk`
        )
      } else if (key === 'app-store') {
        //苹果下载埋点
        analytics.logEvent('hskweb_apple_click', mixpanelParams)
        window.open(
          this.isChina
            ? 'https://apps.apple.com/cn/app/hsk-mock-china/id6453362725'
            : 'https://apps.apple.com/cn/app/hsk-mock/id1624661903'
        )
      } else if (key === 'google-play') {
        //谷歌下载埋点
        analytics.logEvent('hskweb_google_click', mixpanelParams)
        window.open('https://play.google.com/store/apps/details?id=com.wohui.mocktest')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 20px;
  padding-bottom: 360px;
  background: url('@/assets/images/hsk/need-download-bg.png') no-repeat center;
  background-size: 100% auto;
  background-position: center bottom 20px;
}

.header {
  display: flex;
  justify-content: flex-end;

  & > img {
    width: 32px;
    height: 32px;
  }
}

.txt {
  width: 100%;
  height: auto;
}
</style>
